import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

export const SectionProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const calculateProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      
      const totalScrollable = documentHeight - windowHeight;
      const scrolled = (scrollTop / totalScrollable) * 100;
      
      setProgress(Math.min(100, Math.max(0, scrolled)));
    };

    calculateProgress();
    window.addEventListener('scroll', calculateProgress, { passive: true });
    
    return () => window.removeEventListener('scroll', calculateProgress);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-1 bg-muted/30">
      <div
        className={cn(
          "h-full bg-gradient-to-r from-primary via-purple-500 to-pink-500 transition-all duration-150 ease-out",
          progress > 0 && "shadow-lg shadow-primary/50"
        )}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
